import { render, staticRenderFns } from "./DealerManage.vue?vue&type=template&id=2a1fa87a&scoped=true"
import script from "./DealerManage.vue?vue&type=script&lang=js"
export * from "./DealerManage.vue?vue&type=script&lang=js"
import style0 from "./DealerManage.vue?vue&type=style&index=0&id=2a1fa87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1fa87a",
  null
  
)

export default component.exports